var _module = require('../components/module');

/*
prefix
prefix a string with whatever you want
*/

_module.filter('prefix', [
    '$log',

    function prefix($log) {
        return function(str, prefixWith) {
            return str !== prefixWith ? ('' + prefixWith + str) : '';
        };
    }
]);


